import request from '@/utils/request'
request.defaults.headers.common['isToken'] = true

export async function insetArticle(data) {
  return request({
    url: '/articles/articles',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: data
  })
}
export async function queryData(userId, currentTab, pageNum = 1, pageSize = 16) {
 
  return request({
    url: '/articles/articles/app/list',
    method: 'get',
    params:{
      userId: userId,
      type: currentTab,
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

// 根据文章ID获取详情
export async function getArticleDetail(id,type) {
  return request({
    // url: `/articles/articles/${id}/${type}`,
     url: `/articles/articles/${id}/${type}`,
    method: 'get'
  })
}


